"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/SupportedLanguages/actions");

var initialState = (0, _immutable.OrderedMap)();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchSupportedLanguagesActionTypes.SUCCESS, function (state, action) {
  return action.payload.data.objects.reduce(function (acc, language) {
    return acc.set(language.tag, language.displayName);
  }, (0, _immutable.OrderedMap)());
}), initialState);

exports.default = _default;
module.exports = exports.default;